<template>
  <div class="table-crud-modal" ref="modal">
    <h2 class="lvl2-heading">Modifier le support</h2>
    <el-form
      :model="params"
      label-position="left"
      :status-icon="true"
      ref="editSupportForm"
      :rules="rules"
    >
      <el-row :gutter="20">
        <el-col>
          <el-form-item prop="name">
            <span>Support:</span>
            <el-input placeholder="Support" v-model="params.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12"></el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col>
          <el-form-item prop="pharmacist_id">
            <span>Pharmacien:</span>
            <el-select
              no-data-text="..."
              popper-class="pharmacist-f"
              class="pharmacist-select"
              v-model="params.pharmacist_id"
              placeholder="Pharmacien"
              filterable
              default-first-option
            >
              <el-option
                v-for="pharmacist in pharmacists"
                :key="`pharmacist__f-${pharmacist.first_name}`"
                :label="pharmacist.full_name"
                :value="pharmacist.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12"></el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col>
          <el-form-item prop="format">
            <span>Format:</span>
            <el-input placeholder="Format" v-model="params.format"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12"></el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col>
          <el-form-item prop="type_support_id">
            <span>Type de support:</span>
            <el-select
              no-data-text="..."
              popper-class="supports-f"
              class="supports-select"
              v-model="params.type_support_id"
              placeholder="Type de support"
              filterable
              default-first-option
            >
              <el-option
                v-for="sup in supportstypes.data.options"
                :key="`sup__f-${sup.name}`"
                :label="sup.name"
                :value="sup.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12"></el-col>
      </el-row>
      <el-form-item style="text-align: right">
        <base-button @click.prevent.stop.native="handleSubmit" :fluid="false"
          >Modifier</base-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  Message,
  Input,
  Form,
  FormItem,
  Row,
  Col,
  Option,
  Select
} from "element-ui"
import { mapGetters, mapState } from "vuex"
import { updateSupport } from "@/api/filters"
import { fetchUsers } from "@/api/users"
import { emitter } from "@/utils"
import { loaderMixin } from "@/mixins"

export default {
  components: {
    ElInput: Input,
    ElForm: Form,
    ElFormItem: FormItem,
    ElRow: Row,
    ElCol: Col,
    ElSelect: Select,
    ElOption: Option
  },
  computed: {
    ...mapState(["supportstypes"]),
    ...mapGetters(["modal"])
  },
  data() {
    return {
      pharmacists: [],
      params: {
        name: "",
        type_support_id: null,
        format: "",
        pharmacist_id: null
      },
      rules: {
        name: [
          {
            trigger: "blur",
            required: true,
            message: "Le nom est obligatoire"
          }
        ],
        type_support_id: [
          {
            trigger: "blur",
            required: true,
            message: "Le type est obligatoire"
          }
        ],
        format: [
          {
            trigger: "blur",
            required: true,
            message: "Le format est obligatoire"
          }
        ],
        pharmacist_id: [
          {
            trigger: "blur",
            required: true,
            message: "Le pharmacien est obligatoire"
          }
        ]
      }
    }
  },
  mixins: [loaderMixin],

  methods: {
    handleSubmit() {
      this.$refs["editSupportForm"].validate(valid => {
        if (valid) {
          this.openLoader(this.$refs.modal)

          updateSupport(this.modal.payload.support.id, this.params)
            .then(() => {
              Message.success("Support modifié")

              emitter.$emit("update-table")
              this.closeLoader()
              this.$store.dispatch("closeModal")
            })
            .catch(() => {
              /* if (
                err.reponse &&
                err.reponse.error &&
                err.response.error.message
              ) {
                Message.error(err.response)
              } else {
                Message.error("Support n'est pas modifié.")
              } */
              this.closeLoader()
            })
        }
      })
    }
  },
  async created() {
    this.$store.dispatch("getSupportsTypes")
    const { data } = await fetchUsers({ role: "pharmacist" })
    // this.closeLoader()
    this.pharmacists = data
    const { support } = this.modal.payload
    for (const key in this.params) {
      if (support.hasOwnProperty(key)) {
        this.params[key] = support[key]
      }
    }
  }
}
</script>
